// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"465":"e08e542e","482":"0a0e4928","769":"1d64363c","817":"d7eb5a35"}[chunkId] + ".chunk.css";
};